import React, { useEffect } from 'react';
import '../App.css';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../App';
import Loader from '../components/Loader';
import { useTranslation } from 'react-i18next';
import NewUserModal from '../components/NewUserModal';
interface PageTemplateProps {
    pageTitle: string;
    isAuthRequired?: boolean;
    children?: React.ReactNode;
    isLoading?: boolean;
}

function PageTemplate({ pageTitle, children, isAuthRequired, isLoading }: PageTemplateProps) {

    const { user, loading } = useUser();
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    useEffect(() => {
        const appName = t('app.name');
        document.title = pageTitle ? `${pageTitle} - ${appName}` : appName;
    }, [pageTitle, t]);

    useEffect(() => {
        if (!isAuthRequired || loading) return;

        if (!user && isAuthRequired) {
            window.location.href = '/login';
        }
    }, [user, loading, navigate, isAuthRequired]);

    return (
        <Loader isLoading={loading}>
            {user ? <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <NewUserModal />
                <h1 className="App-title">{pageTitle}</h1>
                <Loader isLoading={isLoading ?? false} size='container'>{children}</Loader>

            </Box> : null}
        </Loader>
    );
}

export default PageTemplate;
